"use strict";
/* Autogenerated file. Do not edit manually. */

/* tslint:disable */

/* eslint-disable */

var _classCallCheck = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IAuctionHouse__factory = void 0;

var ethers_1 = require("ethers");

var IAuctionHouse__factory = /*#__PURE__*/function () {
  function IAuctionHouse__factory() {
    _classCallCheck(this, IAuctionHouse__factory);
  }

  _createClass(IAuctionHouse__factory, null, [{
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
  }]);

  return IAuctionHouse__factory;
}();

exports.IAuctionHouse__factory = IAuctionHouse__factory;
var _abi = [{
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "uint256",
    name: "auctionId",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "address",
    name: "tokenContract",
    type: "address"
  }, {
    indexed: false,
    internalType: "bool",
    name: "approved",
    type: "bool"
  }],
  name: "AuctionApprovalUpdated",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "uint256",
    name: "auctionId",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "address",
    name: "tokenContract",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "sender",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "value",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bool",
    name: "firstBid",
    type: "bool"
  }, {
    indexed: false,
    internalType: "bool",
    name: "extended",
    type: "bool"
  }],
  name: "AuctionBid",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "uint256",
    name: "auctionId",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "address",
    name: "tokenContract",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "tokenOwner",
    type: "address"
  }],
  name: "AuctionCanceled",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "uint256",
    name: "auctionId",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "address",
    name: "tokenContract",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "duration",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "reservePrice",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "address",
    name: "tokenOwner",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "curator",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint8",
    name: "curatorFeePercentage",
    type: "uint8"
  }, {
    indexed: false,
    internalType: "address",
    name: "auctionCurrency",
    type: "address"
  }],
  name: "AuctionCreated",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "uint256",
    name: "auctionId",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "address",
    name: "tokenContract",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "duration",
    type: "uint256"
  }],
  name: "AuctionDurationExtended",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "uint256",
    name: "auctionId",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "address",
    name: "tokenContract",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "tokenOwner",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "curator",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "winner",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "amount",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "curatorFee",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "address",
    name: "auctionCurrency",
    type: "address"
  }],
  name: "AuctionEnded",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "uint256",
    name: "auctionId",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: true,
    internalType: "address",
    name: "tokenContract",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "reservePrice",
    type: "uint256"
  }],
  name: "AuctionReservePriceUpdated",
  type: "event"
}, {
  inputs: [{
    internalType: "uint256",
    name: "auctionId",
    type: "uint256"
  }],
  name: "cancelAuction",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "address",
    name: "tokenContract",
    type: "address"
  }, {
    internalType: "uint256",
    name: "duration",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "reservePrice",
    type: "uint256"
  }, {
    internalType: "address payable",
    name: "curator",
    type: "address"
  }, {
    internalType: "uint8",
    name: "curatorFeePercentages",
    type: "uint8"
  }, {
    internalType: "address",
    name: "auctionCurrency",
    type: "address"
  }],
  name: "createAuction",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "auctionId",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amount",
    type: "uint256"
  }],
  name: "createBid",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "auctionId",
    type: "uint256"
  }],
  name: "endAuction",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "auctionId",
    type: "uint256"
  }, {
    internalType: "bool",
    name: "approved",
    type: "bool"
  }],
  name: "setAuctionApproval",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "auctionId",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "reservePrice",
    type: "uint256"
  }],
  name: "setAuctionReservePrice",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];